module.exports = __webpack_public_path__ + "img/eye-on-light.7841738.svg";